module.exports = __webpack_public_path__ + "static/media/icon-teams-roles-unchecked.72906363.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-teams-roles-unchecked.svg
// module id = 1858
// module chunks = 0